import React from "react";
import AdBanner from "./AdBanner";

const About = () => {
  return (
    <section>
      <h2>Hakkımızda / Proje Tanıtımı</h2>
      <img
        src="/intro.JPG"
        alt="Proje Tanıtımı"
        className="intro-image"
      />
      <p>
        ParkGüven, şehir içi otoparkları anlık olarak haritada gösteren,
        kullanıcı dostu ve güvenli bir mobil uygulamadır. Belediyelere, kamu
        kurumlarına ve özel otoparklara dijital gelir modeli sunmayı hedefler.
        İlk yıl belediyelere ücretsiz.
      </p>
      
      {/* Advertisement */}
      <AdBanner
        imageSrc="/ad_ayfoto.JPG"
        altText="Ayfoto Reklamı"
        companyName="Ayfoto - Fotoğraf Hizmetleri"
        link="#"
        className="horizontal"
      />
    </section>
  );
};

export default About;
